module.exports = __webpack_public_path__ + "media/thieme/Greenberg-Flashcards_1024x1536px_ok-b4d66032.jpg";